import { useContext } from 'react';

// Components
import { Context } from '@/components/Store';
// Modules
import { isSupporter, setInnerHTML } from '@/lib/util';
import { languageStrings } from '@/l18n/de';

const More = () => {
  const [state] = useContext(Context);

  const supporter = isSupporter(state.bundle);
  const contactEmail = supporter ? 'meinbeitrag@derStandard.at' : 'digitalabo@derStandard.at';

  return state?.bundle ? (
    <section className="product-more">
      <h3>{languageStrings.more.header}</h3>
      <p dangerouslySetInnerHTML={setInnerHTML(languageStrings.more.productQuestions(contactEmail))}></p>

      {!supporter ? (
        <>
          <h3>{languageStrings.more.benefits}</h3>
          <p dangerouslySetInnerHTML={setInnerHTML(languageStrings.more.goToOffers)}></p>
        </>
      ) : null}
    </section>
  ) : null;
};

export { More };
